import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import _ from "lodash";
import {getPrimitiveArray} from "../../../../../helpers/utils/Utils";
import Form from "../../../../../components/common/form/Form";
import CommonChosenInput from "../../Sections/CommonChosenInput";
import Modal from "../../../../../components/common/form/Modal";
import ButtonTray from "../../../../../components/common/form/ButtonTray";
import {
    useCheckTaxOrderResultValidQuery,
    useGetCertificateOptionsByOrderIdQuery,
    useUpdateTaxAccountsMutation
} from "../../../ordersApi";
import {useGetProductTaskListQuery} from "../../../productsApi";


interface Certificate {
    propertyIds: any[];
}

interface UpdateTaxModalProps {
    show: boolean;
    setShow: (show: boolean) => void;
    propertyResultTaxList: string[];
    setPropertyResultTaxList: (list: string[]) => void;
    taxCheckedList: string[];
    setTaxCheckedList: (list: string[]) => void;
    setReloadTaxButton: (reload: boolean) => void;
    certificate: Certificate;
    orderData: any;
    productId: string;
    orderResultData: any;
    setIsValidDataForPdfGenerate: (value: boolean) => void;
    certificateOptions?: any;
}

export default function UpdateTaxModal({
    show,
    setShow,
    propertyResultTaxList,
    setPropertyResultTaxList,
    taxCheckedList,
    setTaxCheckedList,
    setReloadTaxButton,
    certificate,
    orderData,
    productId,
    orderResultData,
    setIsValidDataForPdfGenerate,
    certificateOptions
}: UpdateTaxModalProps) {
    const [additionalList, setAdditionalList] = useState<any[]>([]);
    const [date, setDate] = useState<string>("");
    const { orderId } = useParams<{ orderId: string }>();
    const [taxYear, setTaxYear] = useState<number>();
    const [updateTaxAccounts] = useUpdateTaxAccountsMutation();
    const {
        refetch: refetchProductTaskList,
    } = useGetProductTaskListQuery(productId, { skip: true });

    const {
        refetch: refetchTaxOrderValidation,
    } = useCheckTaxOrderResultValidQuery(orderResultData?.data, { skip: true });

    const {
        refetch: refetchCertificateOptions,
    } = useGetCertificateOptionsByOrderIdQuery(orderId, { skip: true });

    useEffect(() => {
        if (certificateOptions?.data) {
            setTaxYear(certificateOptions.data.selectedTaxYear);
        }
    }, [certificateOptions]);


    const populateScraperCheckboxes = () => {
        let shownProperties: string[] = [];
        let checkedProperties: string[] = [];

        function populateFromCertificate(property: any) {
            if (!property?.id || property.id === 'N/A') return;

            shownProperties.push(property.id);

            let matchingProperty = orderData?.data?.properties?.find(
                (cur: any) => cur.propertyResult.taxId === property.id
            );

            if (matchingProperty?.propertyResult?.skipAutomation) return;

            checkedProperties.push(property.id);
        }

        const populateFromOrder = (property: any) => {
            let propertyResult = property.propertyResult;
            if (!propertyResult?.taxId) return;

            shownProperties = _.union(shownProperties, [propertyResult.taxId]);

            if (propertyResult.skipAutomation) return;

            checkedProperties = _.union(checkedProperties, [propertyResult.taxId]);
        }
        if (certificate?.propertyIds?.length) {
            certificate.propertyIds.forEach(populateFromCertificate);
        }

        if (shownProperties.length === 0 && orderData?.data?.properties?.length) {
            orderData?.data?.properties?.forEach(populateFromOrder);
        }

        setPropertyResultTaxList(shownProperties);
        setTaxCheckedList(JSON.parse(JSON.stringify(checkedProperties)));


    }


    useEffect(populateScraperCheckboxes, []);

    function dismissModal(e: React.MouseEvent) {
        e.preventDefault();
        setShow(false);
    }

    const handleTaxYearChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        if (value.length > 4) return;
        const enteredYear = parseInt(value, 10);
        const currentYear = new Date().getFullYear();
        if (enteredYear > currentYear) return;
        setTaxYear(enteredYear);
    };

    const changeWebUpdateList = (e: React.ChangeEvent<HTMLInputElement>, propertyId: string) => {
        const index = taxCheckedList.indexOf(propertyId);
        if (index > -1) {
            taxCheckedList.splice(index, 1);
        } else {
            taxCheckedList.push(propertyId);
        }
        setTaxCheckedList([...taxCheckedList]);
    };

    const handleSubmit = async (e: any) => {
        e.preventDefault();

        let tempSubmitList = [];
        tempSubmitList.push(...taxCheckedList);
        tempSubmitList.push(...getPrimitiveArray(additionalList, "value"));

        if (tempSubmitList.length > 0 && orderData.data) {
            setShow(false);
            setReloadTaxButton(true);

            const listToSubmit = tempSubmitList.map((cur) => ({
                accountNumber: cur,
                orderPropertyId: orderData?.data?.properties?.find((curP: any) => curP.propertyResult.taxId === cur)?.id || null
            }));

            try {
                await updateTaxAccounts({
                    accounts: listToSubmit,
                    orderId,
                    productId,
                    taxYear
                }).unwrap();
                setReloadTaxButton(false);
                const [productTasks, taxValidation, certificateOptions] = await Promise.all([
                    refetchProductTaskList(),
                    refetchTaxOrderValidation(),
                    refetchCertificateOptions()
                ]);

                if (taxValidation.data !== undefined) {
                    setIsValidDataForPdfGenerate(taxValidation.data);
                }

            } catch (error: any) {
                setReloadTaxButton(false);
            }
        }
    };
    return (
        <Modal
            title={"Update Taxes"}
            show={show}
            setShow={setShow}
            className={"w-3/6"}
            fields={
                <>
                    <Form onSubmit={handleSubmit} fields={(
                        <>
                            <div className="modal-body">
                                <div className="table_data">
                                    <div className="table-responsive">
                                        <div className="mb-3">
                                            <span><b>Tax Year</b></span>
                                            <input className="form-control border border-text-1 mt-2"
                                                placeholder="Enter tax year..."
                                                type="number"
                                                name="tax_year"
                                                min="1900"
                                                max={new Date().getFullYear()} value={taxYear}
                                                pattern="[0-9]{4}"
                                                title="Please enter a four-digit year."
                                                onChange={handleTaxYearChange}
                                            />
                                        </div>
                                        <table className="table table-hover table-striped w-full">
                                            <thead className="bg-highlight-5 text-[white] relative text-left">
                                                <tr >
                                                    <th>Accounts</th>
                                                </tr>

                                            </thead>

                                            <tbody>
                                                {propertyResultTaxList?.length === 0 && (
                                                    <tr>
                                                        <td >There are no taxes for update</td>
                                                    </tr>
                                                )}
                                                {propertyResultTaxList?.map((curTax: string, index: number) => (
                                                    <tr key={index} className="odd:bg-text-1 hover:bg-text-1 transition cursor-pointer">
                                                        <td>
                                                            <input className="tax_data mr-4" type="checkbox"
                                                                disabled={orderData?.data?.properties?.some((cur: any) => cur.propertyResult.skipAutomation && cur.propertyResult.taxId === curTax)}
                                                                onChange={e => changeWebUpdateList(e, curTax)}
                                                                onClick={() => setDate(curTax + Date.now())}
                                                                checked={taxCheckedList.includes(curTax)} />
                                                            {curTax}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="pt-4">
                                    <span><b>Additional Accounts</b></span>
                                    <CommonChosenInput placeholder="Enter accounts" state={additionalList} setState={setAdditionalList} isRequired={false} />
                                </div>
                                <div className="error_cl mt-2 text-[red]">Any previous changes will be lost. Continue?</div>
                            </div>

                            <ButtonTray
                                buttons={[
                                    {
                                        buttonProps: {
                                            btnText: "Cancel",
                                            onClick: () => setShow(false),
                                            type: "cancel",
                                        },
                                        buttonType: "button",
                                    },
                                    {
                                        buttonProps: {
                                            btnText: "Submit",
                                            type: "submit",
                                            onClick: handleSubmit,
                                            isDisabled:!(taxCheckedList.length > 0 || additionalList.length > 0)
                                           
                                        },
                                        buttonType: "button",
                                    },
                                ]}
                                align="end"
                                gap={2}
                            />
                        </>
                    )} />
                </>
            }
        />
    );
}